export default __webpack_public_path__ + "static/media/retry-red-icon.b61f49b2.svg";